import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { intrinsic, iframe, placeholder } from './styles';
export function GCalendar(props) {
  return jsx("div", Object.assign({
    css: intrinsic,
    className: "has-iframe"
  }, process.env.ENV_RAW ? null : props.uiEvents), jsx("iframe", {
    css: [iframe, props.edit ? placeholder : null],
    title: "Google kalend\xE1\u0159",
    frameBorder: "0",
    src: props.src,
    scrolling: "no"
  }), props.children);
}